import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { restrcitorService } from '../services/restrictorService'

export const useGet = (key, { accountId, accessToken }) => {
  return useQuery([key], () => restrcitorService.getExistingBoardRestrictions(accountId, accessToken), { enabled: !!accessToken && !!accountId })
}

export const useUpdate = (key, setError) => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ restriction, accountId, onSetLoadState, accessToken }) => {
      const updatedRestriction = await restrcitorService.editRestriction(restriction, accountId, accessToken)
      onSetLoadState('edit', false)
      return updatedRestriction
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([key])
      },
      onError: ({ message }) => {
        setError(message)
      },
    }
  )
}

export const useUpdateAccount = (key, setError) => {
  const queryClient = useQueryClient()
  return useMutation(({ restrictionAccount, accessToken }) => restrcitorService.updateRestrictionAccount(restrictionAccount, accessToken), {
    onSuccess: () => {
      queryClient.invalidateQueries([key])
    },
    onError: ({ message }) => {
      setError(message)
    },
  })
}

export const useUpdateAccountKey = (key, setError) => {
  const queryClient = useQueryClient()
  return useMutation(({ key, value, accountId, accessToken }) => restrcitorService.updateRestrictionAccountKey(key, value, accountId, accessToken), {
    onSuccess: () => {
      queryClient.invalidateQueries([key])
    },
    onError: ({ message }) => {
      setError(message)
    },
  })
}

export const useDelete = (key) => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ restriction, accountId, onSetLoadState, accessToken, monday }) => {
      const deletedRestriction = await restrcitorService.deleteRestriction(restriction._id, accountId, accessToken)
      onSetLoadState('delete', false)
      return deletedRestriction
    },
    {
      onSuccess: (data, variables) => {
        queryClient.setQueryData([key], data.data)
        variables.monday.execute('notice', {
          message: `The restriction on ${variables.restriction.board.label} was successfully deleted!`,
          type: 'success', // or "error" (red), or "info" (blue)
          timeout: 10000,
        })
      },
      onError: (data, variables) => {
        variables.monday.execute('notice', {
          message: 'Error: ' + data.response.data.error,
          type: 'error', // or "error" (red), or "info" (blue)
          timeout: 10000,
        })
        variables.onSetLoadState('delete', false)
      },
    }
  )
}

export const useCreate = (key, setError) => {
  const queryClient = useQueryClient()
  return useMutation(({ newRestriction, accountId, accessToken }) => restrcitorService.addBoardRestriction(newRestriction, accountId, accessToken), {
    onSuccess: () => {
      queryClient.invalidateQueries([key])
    },
  })
}
